import { useEffect } from 'react';
import posthog from 'posthog-js';

import type { Me } from '@/entities/me';

export function usePosthogSyncMe(me: Me | undefined) {
  useEffect(
    function () {
      if (!me) {
        return;
      }

      const distinctId = me.id;
      const currentDistinctId = posthog.get_distinct_id();

      if (distinctId === currentDistinctId) {
        return;
      }

      posthog.reset();
      posthog.identify(distinctId, {
        email: me.email,
        name: me.displayName,
        tenant: me.tenant,
        ...(me.role && { role: me.role }),
        ...(me.config?.type && { customer_type: me.config.type }),
      });
    },
    [me],
  );
}
